import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

@InjectModule({ stateFactory: true }, module)
export default class pathModule extends InjectVuexModule {
    path = '';

    @Mutation
    setPath(path: 'sp' | 'hub') {
        this.path = path;
    }
}
